import React, { SVGProps } from 'react';

const SvgMapsHomeWork = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            viewBox="0 -960 960 960"
            fill="currentColor"
            width="24"
            height="24"
            className="svg-icon"
            {...props}
        >
            <path d="M264-227q19-18 43.5-44.5T355-328q23-30 38-61.5t15-60.5q0-65-40.5-107.5T264-600q-63 0-103.5 42.5T120-450q0 29 15 60.5t38 61.5q23 30 47.5 56.5T264-227ZM80-80v-80h138q-28-26-59-59t-57-71q-26-38-44-78t-18-82q0-98 64-164t160-66q96 0 160 66t64 164q0 42-18 82t-44 78q-26 38-57 71t-59 59h570v80H80Zm524-516Zm-4 356-75-121 45-79 30 49 30-49h170v-360H400v40h-80v-40q0-33 23.5-56.5T400-880h400q33 0 56.5 23.5T880-800v360q0 33-23.5 56.5T800-360H675l-75 120Zm-77-280 81-49 81 49-21-92 72-63-95-8-37-87-37 87-95 8 72 63-21 92ZM264-400q25 0 42.5-17.5T324-460q0-25-17.5-42.5T264-520q-25 0-42.5 17.5T204-460q0 25 17.5 42.5T264-400Zm0-60Z" />
        </svg>
    );
};

export default SvgMapsHomeWork;
